var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVipMemberIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 95.018,
    height: 12,
    viewBox: "0 0 95.018 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "0g82qxnima",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f2ac43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.537,
    stopColor: "#fdf57d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f2ac43"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "322cbh6k7b",
    x1: 1.152,
    y1: 0.231,
    x2: 0,
    y2: 0.232,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fd5d00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gold"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 10544"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46173",
    d: "M.17-3.7h1.894l.6-3.521a1.03 1.03 0 0 1 .988-.964c.5 0 .763.341.682.895L3.722-3.7h1.824l.6-3.552a.984.984 0 0 1 .976-.933c.484 0 .771.321.686.914L7.2-3.7h1.89l.666-4c.217-1.264-.437-2.031-1.556-2.031a2.166 2.166 0 0 0-1.991 1.17h-.058a1.278 1.278 0 0 0-1.425-1.17 2.061 2.061 0 0 0-1.875 1.17h-.066l.178-1.092h-1.8zm12.855.112a3.1 3.1 0 0 0 3.126-1.925l-1.727-.05a1.237 1.237 0 0 1-1.135.608c-.74 0-1.1-.438-.976-1.193l.012-.07h3.962l.074-.473c.325-1.956-.682-3.037-2.37-3.037a3.464 3.464 0 0 0-3.463 3.075c-.322 1.899.631 3.061 2.498 3.061zm-.5-3.73a1.352 1.352 0 0 1 1.29-1.042.84.84 0 0 1 .885 1.038zM16.848-3.7h1.894l.6-3.521a1.03 1.03 0 0 1 .988-.964c.5 0 .763.341.682.895L20.4-3.7h1.824l.6-3.552a.984.984 0 0 1 .976-.933c.484 0 .771.321.686.914l-.6 3.571h1.89l.666-4c.213-1.255-.442-2.022-1.557-2.022a2.166 2.166 0 0 0-1.991 1.17h-.062A1.278 1.278 0 0 0 21.4-9.731a2.061 2.061 0 0 0-1.875 1.17h-.066l.178-1.092h-1.8zm10.09 0h1.875l.155-.964h.074a1.4 1.4 0 0 0 1.487 1.05c1.317 0 2.556-1.03 2.889-3.056.349-2.1-.612-3.056-1.855-3.056a2.11 2.11 0 0 0-1.867 1.1h-.039l.492-3h-1.894zm2.351-2.975c.155-.972.662-1.573 1.356-1.573s.984.616.829 1.573-.651 1.584-1.348 1.584-.992-.623-.837-1.588zm7.394 3.087a3.1 3.1 0 0 0 3.126-1.925l-1.727-.05a1.237 1.237 0 0 1-1.135.608c-.74 0-1.1-.438-.976-1.193l.012-.07h3.962l.074-.473c.325-1.956-.682-3.037-2.37-3.037a3.464 3.464 0 0 0-3.463 3.075c-.323 1.899.63 3.061 2.497 3.061zm-.5-3.73a1.352 1.352 0 0 1 1.29-1.042.84.84 0 0 1 .887 1.042zM40.494-3.7h1.894l.535-3.23A1.4 1.4 0 0 1 44.3-8.119a2.477 2.477 0 0 1 .732.1l.279-1.65a2.24 2.24 0 0 0-.519-.066 1.73 1.73 0 0 0-1.584 1.166h-.062l.182-1.084h-1.84z",
    transform: "translate(49.709 15.293)",
    style: {
      fill: "#f7d152"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 10029"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46171",
    d: "M4.913-11.636H1.568L3.358-.729h4.047l5.411-10.907H9.471l-3.514 7.69h-.086zm11.908 0H13.86L12.049-.729h2.961zm-.4 10.907h2.961l.543-3.238h1.63a4.53 4.53 0 0 0 4.793-3.813c.383-2.322-.98-3.856-3.408-3.856h-4.713zM20.3-6.268l.5-3h1.044c1.044 0 1.555.554 1.406 1.491a1.768 1.768 0 0 1-1.917 1.512z",
    transform: "translate(20.633 12.318)",
    style: {
      fill: "url(#0g82qxnima)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 10028"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46172",
    d: "M129.882 267.216h-4.988a3.209 3.209 0 0 1-.362-.021.991.991 0 0 1-.921-.808q-.375-1.444-.748-2.889c-.373-1.439-.749-2.876-1.118-4.316a1 1 0 0 1 .779-1.288 1.036 1.036 0 0 1 .577.067q1.463.563 2.925 1.129c.267.1.283.1.463-.129q1.283-1.648 2.565-3.3a.993.993 0 0 1 1.65-.008q1.3 1.659 2.591 3.323c.162.208.178.213.419.12.969-.375 1.94-.746 2.908-1.125a1.019 1.019 0 0 1 1.4 1.235q-.936 3.6-1.869 7.2a1.037 1.037 0 0 1-1.125.807h-5.144z",
    transform: "translate(-121.705 -255.218)",
    style: {
      fill: "url(#322cbh6k7b)"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVipMemberIcon);
export default __webpack_public_path__ + "static/media/vipMemberIcon.64cc04e84b43bc043b4d18e3d3231a40.svg";
export { ForwardRef as ReactComponent };